var map = {
	"./ico-automation.svg": 58550,
	"./ico-autoresponder.svg": 98132,
	"./ico-campaign.svg": 58017,
	"./ico-close.svg": 5553,
	"./ico-contact-book.svg": 91901,
	"./ico-dashboard.svg": 11625,
	"./ico-filter-range.svg": 7273,
	"./ico-form.svg": 35013,
	"./ico-gallery.svg": 35175,
	"./ico-list.svg": 82923,
	"./ico-logs.svg": 57234,
	"./ico-no-api.svg": 29525,
	"./ico-no-data.svg": 86495,
	"./ico-no-domain.svg": 33291,
	"./ico-papper.svg": 50551,
	"./ico-recipients.svg": 87323,
	"./ico-report.svg": 91577,
	"./ico-segment.svg": 10802,
	"./ico-smtp.svg": 59467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89195;